import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    DragDropModule,
    MatTabsModule,
    MatDialogModule
  ],
  exports: [
    BrowserAnimationsModule,
    DragDropModule,
    MatTabsModule,
    MatDialogModule
  ],
  declarations: []
})
export class MaterialModule { }
